<template>
  <section class="footer-links outer">
    <div class="container">
      <ul class="footer-links__link-list">
        <li v-for="menu in menue" v-bind:key="menu.id" class="footer-links__list-item">
          <router-link v-bind:to="menu.url">
            {{ menu.menue }}
          </router-link>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FooterMenue',
  props: {
    menue: {
      type: Object,
    },
  },
};
</script>
